import { Column } from 'react-table'

import { HeaderWithSort } from '@components/Table/HeaderWithSort'
import { SortEnum } from '@interfaces/SortEnum'
import { SalesAnalyticsDataTableType } from '@models/myWriting/salesAndAnalytics/SalesAnalyticsDataTableType'
import { SortTableType } from './interface'

export function columnsSales({
  sortParams,
  bookId,
  isMobile,
  handleSortChange,
}: {
  sortParams: SortTableType
  bookId?: number
  isMobile: boolean
  handleSortChange: (sortKey: string, sortValue: SortEnum) => void
}): Column[] {
  const columns: Column[] = [
    {
      Header: (
        <HeaderWithSort
          text={bookId ? 'ชื่อตอน' : 'ชื่อเรื่อง'}
          sortKey='bookTitle'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'bookTitle',
      Cell: ({ record }: { record: SalesAnalyticsDataTableType }) => (
        <div>{record.bookTitle}</div>
      ),
      minWidth: 120,
      width: 200,
    },
    {
      Header: (
        <HeaderWithSort
          text='จำนวน(เหรียญ)'
          sortKey='total'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'total',
      Cell: ({ record }: { record: SalesAnalyticsDataTableType }) => (
        <div>{record.total.toLocaleString()}</div>
      ),
      minWidth: 120,
      width: 200,
    },
  ]

  if (!isMobile) {
    columns.unshift({
      Header: <div />,
      id: 'emptyColumn',
      Cell: () => <div />,
      minWidth: 150,
      width: 150,
    })
  }

  return columns
}

export function columnsDonation({
  sortParams,
  bookId,
  isMobile,
  handleSortChange,
}: {
  sortParams: SortTableType
  bookId?: number
  isMobile: boolean
  handleSortChange: (sortKey: string, sortValue: SortEnum) => void
}): Column[] {
  const columns: Column[] = [
    {
      Header: (
        <HeaderWithSort
          text={bookId ? 'ชื่อตอน' : 'ชื่อเรื่อง'}
          sortKey='bookTitle'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'bookTitle',
      Cell: ({ record }: { record: SalesAnalyticsDataTableType }) => (
        <div>{record.bookTitle}</div>
      ),
      minWidth: 120,
      width: 200,
    },
    {
      Header: (
        <HeaderWithSort
          text='ตัวละคร'
          sortKey='characterName'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'characterName',
      Cell: ({ record }: { record: SalesAnalyticsDataTableType }) => (
        <div>{record.characterName}</div>
      ),
      minWidth: 120,
      width: 200,
    },
    {
      Header: (
        <HeaderWithSort
          text='จำนวน(เหรียญ)'
          sortKey='total'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'total',
      Cell: ({ record }: { record: SalesAnalyticsDataTableType }) => (
        <div>{record.total.toLocaleString()}</div>
      ),
      minWidth: 120,
      width: 200,
    },
  ]

  if (!isMobile) {
    columns.unshift({
      Header: <div />,
      id: 'emptyColumn',
      Cell: () => <div />,
      minWidth: 150,
      width: 150,
    })
  }

  return columns
}

export function columnsView({
  sortParams,
  bookId,
  isMobile,
  handleSortChange,
}: {
  sortParams: SortTableType
  bookId?: number
  isMobile: boolean
  handleSortChange: (sortKey: string, sortValue: SortEnum) => void
}): Column[] {
  const columns: Column[] = [
    {
      Header: (
        <HeaderWithSort
          text={bookId ? 'ชื่อตอน' : 'ชื่อเรื่อง'}
          sortKey='bookTitle'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'bookTitle',
      Cell: ({ record }: { record: SalesAnalyticsDataTableType }) => (
        <div>{record.bookTitle}</div>
      ),
      minWidth: 120,
      width: 200,
    },
    {
      Header: (
        <HeaderWithSort
          text='จำนวน(วิว)'
          sortKey='total'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'total',
      Cell: ({ record }: { record: SalesAnalyticsDataTableType }) => (
        <div>{record.total.toLocaleString()}</div>
      ),
      minWidth: 120,
      width: 200,
    },
  ]

  if (!isMobile) {
    columns.unshift({
      Header: <div />,
      id: 'emptyColumn',
      Cell: () => <div />,
      minWidth: 150,
      width: 150,
    })
  }

  return columns
}

export function columnsLike({
  sortParams,
  isMobile,
  handleSortChange,
}: {
  sortParams: SortTableType
  isMobile: boolean
  handleSortChange: (sortKey: string, sortValue: SortEnum) => void
}): Column[] {
  const columns: Column[] = [
    {
      Header: (
        <HeaderWithSort
          text='ชื่อเรื่อง'
          sortKey='bookTitle'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'bookTitle',
      Cell: ({ record }: { record: SalesAnalyticsDataTableType }) => (
        <div>{record.bookTitle}</div>
      ),
      minWidth: 120,
      width: 200,
    },
    {
      Header: (
        <HeaderWithSort
          text='จำนวน(ครั้ง)'
          sortKey='total'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'total',
      Cell: ({ record }: { record: SalesAnalyticsDataTableType }) => (
        <div>{record.total.toLocaleString()}</div>
      ),
      minWidth: 120,
      width: 200,
    },
  ]

  if (!isMobile) {
    columns.unshift({
      Header: <div />,
      id: 'emptyColumn',
      Cell: () => <div />,
      minWidth: 150,
      width: 150,
    })
  }

  return columns
}

export function columnsShelfAdded({
  sortParams,
  isMobile,
  handleSortChange,
}: {
  sortParams: SortTableType
  isMobile: boolean
  handleSortChange: (sortKey: string, sortValue: SortEnum) => void
}): Column[] {
  const columns: Column[] = [
    {
      Header: (
        <HeaderWithSort
          text='ชื่อเรื่อง'
          sortKey='bookTitle'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'bookTitle',
      Cell: ({ record }: { record: SalesAnalyticsDataTableType }) => (
        <div>{record.bookTitle}</div>
      ),
      minWidth: 120,
      width: 200,
    },
    {
      Header: (
        <HeaderWithSort
          text='จำนวน(ครั้ง)'
          sortKey='total'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'total',
      Cell: ({ record }: { record: SalesAnalyticsDataTableType }) => (
        <div>{record.total.toLocaleString()}</div>
      ),
      minWidth: 120,
      width: 200,
    },
  ]

  if (!isMobile) {
    columns.unshift({
      Header: <div />,
      id: 'emptyColumn',
      Cell: () => <div />,
      minWidth: 150,
      width: 150,
    })
  }

  return columns
}
